// extracted by mini-css-extract-plugin
export default {"eachdiv":"Activity_eachdiv__H2NYb","subdiv":"Activity_subdiv__vWPae"};